import angular from 'angular';
import './periodictasks.service.js';

class PeriodicTasksCtrl {
    /*@ngInject*/
    constructor(logger, PeriodicTasksSvc) {
        this.logger = logger;
        this.PeriodicTasksSvc = PeriodicTasksSvc;
    }

    $onInit() {
        let vm = this;

        var defaultCellTemplate = '<div class="ui-grid-cell-contents"">{{COL_FIELD CUSTOM_FILTERS}}</div>';

        // ---------------
        // Data API
        // ---------------
        vm.gridOptions = {
            columnDefs: [
                {
                    name: 'status',
                    displayName: 'perioic_tasks.status',
                    headerCellFilter: 'translate',
                    cellTemplate:
                        '<div class="text-center">' +
                        '<i class="fa fa-lg" ng-class="row.entity.getStatusIcon()" style="padding-top:8px;" ng-style="{color: row.entity.getStatusColor()}"></i></div>',
                    enableSorting: false,
                    width: 90,
                    cellClass: 'pointer defaultcursor'
                },
                {
                    name: 'name',
                    displayName: 'perioic_tasks.name',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer defaultcursor'
                },
                {
                    name: 'executor',
                    displayName: 'perioic_tasks.executor',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer defaultcursor'
                },
                {
                    name: 'startDate',
                    displayName: 'perioic_tasks.start_date',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellFilter: "date:'short'",
                    width: 140,
                    cellClass: 'pointer defaultcursor'
                },
                {
                    name: 'endDate',
                    displayName: 'perioic_tasks.end_date',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellFilter: "date:'short'",
                    width: 140,
                    cellClass: 'pointer defaultcursor'
                },
                {
                    name: 'faillureDate',
                    displayName: 'perioic_tasks.faillure_date',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellFilter: "date:'short'",
                    width: 140,
                    cellClass: 'pointer defaultcursor'
                },
                {
                    name: 'lastExecutor',
                    displayName: 'perioic_tasks.last_executor',
                    headerCellFilter: 'translate',
                    cellTemplate: defaultCellTemplate,
                    cellClass: 'pointer defaultcursor'
                },
                {
                    name: 'action',
                    displayName: '',
                    cellTemplate:
                        '<div class="ui-grid-cell-contents" style="padding:0px;">' +
                        '<button type="button" class="btn btn-link btn-md" ng-hide="!row.entity.unlockEnabled()" ng-click="grid.appScope.$ctrl.unlockTask(row)">' +
                        '<i class="fa fa-lg fa-unlock" style="color: red;"></i> {{\'perioic_tasks.action_unlock\' | translate}}</button>' +
                        '<button type="button" class="btn btn-link btn-md" ng-hide="!row.entity.executeEnabled()" ng-click="grid.appScope.$ctrl.executeTask(row)">' +
                        '<i class="fa fa-lg fa-play-circle" style="color: green;"></i> {{\'perioic_tasks.action_execute\' | translate}}</button>' +
                        '</div>',
                    cellClass: 'pointer',
                    enableSorting: false,
                    width: 120
                }
            ],
            exporterOlderExcelCompatibility: true,
            onRegisterApi: onRegisterApi,
            enableSorting: true,
            enableColumnMenus: false,
            enableVerticalScrollbar: false
        };

        // Grille
        function onRegisterApi(gridApi) {
            vm.gridApi = gridApi;
        }

        vm.tasksPromise = null;

        // ---------------
        // Function API
        // ---------------
        vm.refresh = refresh;
        vm.unlockTask = unlockTask;
        vm.executeTask = executeTask;
        vm.getGridHeight = getGridHeight;

        function refresh() {
            vm.gridOptions.data = [];
            search();
        }

        search();

        function search() {
            vm.tasksPromise = vm.PeriodicTasksSvc.search();
            vm.tasksPromise.then(
                function(data) {
                    vm.gridOptions.data = data;
                },
                function() {
                    vm.logger.error('error.generic');
                }
            );
        }

        function unlockTask(row) {
            vm.PeriodicTasksSvc.unlock(row.entity.name).then(
                function() {
                    vm.logger.success('La tâche ' + row.entity.name + ' a été débloquée');
                    //activer le bouton <Lancer>
                    row.entity.executor = null;
                },
                function() {
                    vm.logger.error('La tâche ' + row.entity.name + " n'a pas été débloquée");
                }
            );
        }

        function executeTask(row) {
            vm.PeriodicTasksSvc.execute(row.entity.name);
            vm.logger.success('La tâche ' + row.entity.name + ' est lancée');
        }

        /**
         * Fournit la hauteur de la grid en fonction de la taille des pages.
         */
        function getGridHeight() {
            var rowHeight = 30;
            return {
                height: this.gridApi.core.getVisibleRows(this.gridApi.grid).length * rowHeight + 81 + 'px'
            };
        }
    }
}

angular.module('app.admin.periodictasks').component('periodictasks', {
    templateUrl: require('./periodictasks.html'),
    controller: PeriodicTasksCtrl
});
